import React, { Component } from 'react'

class Hero extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div>
        <section className="hero is-medium registrasi" id="registrasi">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">{this.props.title}</h1>
              <h2 className="subtitle">{this.props.subtitle}</h2>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
export default Hero;